import { UserRoles, type SafetyRepAssignment } from '../../../api/queries';

export const EMPTY_SAFETY_REP: SafetyRepAssignment = {
  isMain: false,
  teamIds: [],
};

/** A safety representative represents at least one team, except the main one */
export const safetyRepError = (assignment: SafetyRepAssignment) =>
  !assignment.isMain && assignment.teamIds.length === 0 ? 'teamsRequired' : null;

export const filterTeams = <T extends { name: string }>(teams: T[], query: string) => {
  const needle = query.trim().toLocaleLowerCase('nb');
  return needle ? teams.filter((team) => team.name.toLocaleLowerCase('nb').includes(needle)) : teams;
};

export const toggleTeam = (assignment: SafetyRepAssignment, teamId: number): SafetyRepAssignment => ({
  ...assignment,
  teamIds: assignment.teamIds.includes(teamId)
    ? assignment.teamIds.filter((id) => id !== teamId)
    : [...assignment.teamIds, teamId],
});

export const sameAssignment = (a: SafetyRepAssignment, b: SafetyRepAssignment) =>
  a.isMain === b.isMain && [...a.teamIds].sort().join() === [...b.teamIds].sort().join();

/**
 * The invitation can start with the safety representative role chosen, and their team, as «Kom i gang» opens it:
 * ?rolle=verneombud&team=12&fra=kom-i-gang. Anything else is left out.
 */
export const invitePrefill = (params: URLSearchParams) => {
  const safetyRep = params.get('rolle') === 'verneombud';
  const team = Number(params.get('team'));
  return {
    roles: safetyRep ? [UserRoles.SAFETY_REP as string] : [],
    safetyRep: { ...EMPTY_SAFETY_REP, teamIds: safetyRep && Number.isInteger(team) && team > 0 ? [team] : [] },
    fromGettingStarted: params.get('fra') === 'kom-i-gang',
  };
};
